import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ContactPage.css';

function ContactPage() {
  const navigate = useNavigate();
  const [copied, setCopied] = useState('');

  const handleCopy = (text, label) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(label);
      setTimeout(() => setCopied(''), 2500);
    });
  };

  return (
    <div className="contact-container">
      <div className="contact-header">
        <button className="contact-back-btn" onClick={() => navigate(-1)}>
          ← Back
        </button>

        <h1>Contact & Support</h1>
        <p>We're here to help you and your partner</p>
      </div>

      <div className="contact-grid">

        {/* Email Card */}
        <div className="contact-card">
          <div className="contact-card-icon">📧</div>

          <h3>Email Support</h3>

          <p>
            Send us an email for any questions, issues, or feedback.
            We read every message.
          </p>

          <div className="contact-detail">
            <span className="contact-value">
              couplecheck254@gmail.com
            </span>

            <button
              className="copy-btn"
              onClick={() =>
                handleCopy('couplecheck254@gmail.com', 'email')
              }
            >
              {copied === 'email' ? '✓ Copied' : 'Copy'}
            </button>
          </div>

          <a
            href="mailto:couplecheck254@gmail.com"
            className="contact-action-btn"
          >
            Send Email →
          </a>
        </div>

        {/* SMS Card */}
        <div className="contact-card">
          <div className="contact-card-icon">💬</div>

          <h3>SMS Support</h3>

          <p>
            Send us a text message for quick questions or urgent issues.
          </p>

          <div className="contact-detail">
            <span className="contact-value">0717 470 808</span>

            <button
              className="copy-btn"
              onClick={() => handleCopy('0717470808', 'phone')}
            >
              {copied === 'phone' ? '✓ Copied' : 'Copy'}
            </button>
          </div>

          <a
            href="sms:+254717470808"
            className="contact-action-btn"
          >
            Send SMS →
          </a>
        </div>

        {/* Hours Card */}
        <div className="contact-card hours-card">
          <div className="contact-card-icon">🕘</div>

          <h3>Support Hours</h3>

          <p>
            Our support team is available during the following hours:
          </p>

          <div className="hours-grid">
            <div className="hours-row">
              <span className="hours-day">Monday – Friday</span>

              <span className="hours-time">
                9:00 AM – 5:00 PM EAT
              </span>
            </div>

            <div className="hours-row weekend">
              <span className="hours-day">
                Saturday – Sunday
              </span>

              <span className="hours-time">Closed</span>
            </div>
          </div>

          <p className="hours-note">
            We aim to respond to all emails within 24 hours
            on business days.
          </p>
        </div>

        {/* FAQ Card */}
        <div className="contact-card faq-card">
          <div className="contact-card-icon">❓</div>

          <h3>Common Questions</h3>

          <div className="faq-list">

            <div className="faq-item-contact">
              <h4>How do I cancel my Premium plan?</h4>

              <p>
                Simply do not renew when your 30-day period ends.
                There are no automatic charges.
              </p>
            </div>

            <div className="faq-item-contact">
              <h4>I paid but Premium is not active.</h4>

              <p>
                Email us with your M-Pesa transaction reference
                and we will activate it manually within business hours.
              </p>
            </div>

            <div className="faq-item-contact">
              <h4>I forgot my password or PIN.</h4>

              <p>
                Use the "Forgot Password" link on the login page.
                For PIN reset, go to Profile then Reset PIN.
              </p>
            </div>

            <div className="faq-item-contact">
              <h4>Is my data private?</h4>

              <p>
                Yes. Read our{' '}
                <button
                  className="inline-link"
                  onClick={() => navigate('/terms')}
                >
                  Privacy Policy
                </button>{' '}
                for full details.
              </p>
            </div>

          </div>
        </div>

      </div>

      <div className="contact-footer">
        <p>
          For subscription and payment issues, always include your
          M-Pesa transaction reference number in your message so
          we can help you faster.
        </p>
      </div>
    </div>
  );
}

export default ContactPage;